module.exports = __webpack_public_path__ + "static/media/youtube.0c570463.svg";